import { automationOutreachStepTypes } from "@redotech/redo-model/split";
import * as z from "zod/v4";

/**
 * Metrics for a single variant in an automation outreach split
 */
const variantMetricsSchema_ = z.object({
  treatmentId: z.string(),
  treatmentName: z.string(),
  isControl: z.boolean(),
  // Common metrics
  sends: z.number(),
  // Outreach metrics (email/SMS)
  deliveries: z.number().optional(),
  opens: z.number().optional(),
  uniqueOpens: z.number().optional(),
  clicks: z.number().optional(),
  uniqueClicks: z.number().optional(),
  upsellRevenue: z.number().optional(),
  // Recover metrics
  initialSends: z.number().optional(),
  uniqueCustomerReplies: z.number().optional(),
  recoveredOrders: z.number().optional(),
  recoveredRevenue: z.number().optional(),
  checkoutAbandonments: z.number().optional(),
  controlSuppressed: z.number().optional(),
});
export const variantMetricsSchema: z.ZodType<VariantMetrics> =
  variantMetricsSchema_;
export interface VariantMetrics extends z.infer<typeof variantMetricsSchema_> {}

/**
 * Response containing metrics for all variants in an automation outreach split
 */
const automationOutreachSplitMetricsResponseSchema_ = z.object({
  splitId: z.string(),
  splitName: z.string(),
  startDate: z.string().optional(),
  stepType: z.enum(automationOutreachStepTypes),
  variants: z.array(variantMetricsSchema),
});
export const automationOutreachSplitMetricsResponseSchema: z.ZodType<AutomationOutreachSplitMetricsResponse> =
  automationOutreachSplitMetricsResponseSchema_;
export interface AutomationOutreachSplitMetricsResponse
  extends z.infer<typeof automationOutreachSplitMetricsResponseSchema_> {}

export const getAutomationOutreachSplitMetrics = {
  name: "getAutomationOutreachSplitMetrics" as const,
  input: z.object({ automationId: z.string(), automationStepId: z.string() }),
  output: automationOutreachSplitMetricsResponseSchema.nullable(),
};
